import '@fancyapps/fancybox/dist/jquery.fancybox.min';
//import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import { get_cookie } from "../tools/cookie";


export default class Utils {
    constructor()
    {
        Utils.click();
        Utils.wpet_click();
        Utils.bootstrap();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.block_cover();
        Utils.obfuscation();
        Utils.change_height_nav();
        Utils.hidding_toolbar();
        Utils.tab_module();
        Utils.isotope();
        // Utils.local_pictures();
    }
    
    static click()
    {
        const trigger = '[data-trigger="wpiris-click"]';
        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    ctrl = true
                }
            })
            $( window ).on( 'keyup', function () {
                ctrl = false
            })
            
            $( document ).on( 'click', trigger, function ( e ) {
                if( e.target.tagName.toLowerCase() !== 'a' ) {
                    if (e.which == 1 || e.which == 2) {
                        console.log('test2')
                        let blank = false
                        let url = $(this).find("a").attr("href")
                        if (e.which == 2) {
                            blank = true
                        } // Clic molette
                        if ($(this).find("a").attr("target") == "_blank") {
                            blank = true
                        }
                        if (blank || ctrl) {
                            window.open(url, '_blank')
                        } else {
                            window.location = url
                        }
                        return false
                    }
                }
            } )
        } else {
            $( document ).on( 'click', trigger, function ( e ) {
                let blank = false
                let url   = $( this ).find( "a" ).attr( "href" )
                if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                    blank = true
                }
                if ( blank ) {
                    window.open( url, '_blank' )
                } else {
                    window.location = url
                }
                return false
                
            } )
        }
    }

    static wpet_click()
    {
        const trigger = '[data-trigger="wpet-click"]';

        if ( trigger.length > 0 ) {
            $( document ).on( 'click', trigger, ( e ) => {
                if ( !$( e.target ).hasClass( 'slider-arrow' ) ) {
                    window.location = $( e.currentTarget ).parents( '[data-id="wpet-offer"]' ).find( '[data-id="wpet-offer-link"]' ).attr( 'href' );
                }
            } );
        }
    }
    
    static bootstrap()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"]' ).tooltip( { trigger: "hover" } )
        }

        $( '[data-toggle="popover"]' ).popover();
    }
    
    static fancybox()
    {

        $( '.hentry a:has(>img):not([target="_blank"]):not([nofancybox])' ).attr( 'data-fancybox', 'fancybox' );

        let counterGallery = 0;
        $( '.hentry .wp-block-gallery' ).each( function () {
            counterGallery++;
            $( this ).find( 'a:has(>img)' ).attr( 'data-fancybox', 'wp-block-gallery-' + counterGallery );
        } );

        let counterImage = 0;
        $( '.hentry .wp-block-image' ).each( function () {
            counterImage++;
            $( this ).find( 'a:has(>img)' ).attr( 'data-fancybox', 'wp-block-image-' + counterImage );

            // Remove fancybox on
            let url = $( this ).find( 'a:has(>img)' ).attr('href');
            if( undefined !== url && url.includes('mailto:') ){
                $( this ).find( 'a:has(>img)' ).removeAttr( 'data-fancybox');
            }
        } );

        $( '[data-fancybox]' ).fancybox( {
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            backFocus: false,
            lang: "fr",
            i18n: {
                fr: {
                    CLOSE: Theme.translate.fancybox_close,
                    NEXT: Theme.translate.fancybox_next,
                    PREV: Theme.translate.fancybox_prev,
                    ERROR: Theme.translate.fancybox_error,
                    PLAY_START: Theme.translate.fancybox_start,
                    PLAY_STOP: Theme.translate.fancybox_stop,
                    FULL_SCREEN: Theme.translate.fancybox_full_screen,
                    THUMBS: Theme.translate.fancybox_thumbs,
                    DOWNLOAD: Theme.translate.fancybox_download,
                    SHARE: Theme.translate.fancybox_share,
                    ZOOM: Theme.translate.fancybox_zoom
                },
            },
            caption: function ( instance, item ) {
                let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html()

                if ( !caption ) {
                    caption = $( this ).find( 'img' ).attr( 'title' )
                }

                if ( !caption ) {
                    caption = $( this ).find( 'img' ).attr( 'alt' )
                }

                return caption
            }
        } )
    }
    
    static searchbox()
    {
        const trigger  = '[data-trigger="wpiris-search-layout"]',
              close    = '[data-trigger="wpiris-search-layout-close"]',
              $element = $('[data-id="wpiris-search-layout"]');
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.fadeIn().find('input').focus();
        } )
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.fadeOut();
        } )
    }
    
    static smooth_scroll()
    {
        const trigger = '[data-trigger="wpiris-scroll"]';

        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();

            const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href"),
                duration = 1000

            let scroll_top = $( target ).offset().top - ( undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0 );

            if ( window.matchMedia( "(max-width: 650px)" ).matches ) {
                scroll_top -= 140
            }

            $( 'html, body' ).animate( {
                scrollTop: scroll_top
            }, {
                duration: duration,
                step: ( now, fx ) => {
                    let real_pos = scroll_top;
                    if ( fx.end !== real_pos ) {
                        fx.end = real_pos;
                    }
                }
            });
        })
    }

    static lazy()
    {
        const lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-src], [data-bg], [data-bg-hidpi]'
        });
        window.onbeforeprint = function () {
            lazyLoadInstance.loadAll();
        };
    }

    static block_cover() {
        $( '.wp-block-cover:has(.wp-block-cover__inner-container a)' ).attr( 'data-trigger', 'wpiris-click' )
    }
    
    static obfuscation()
    {
        let element = "[data-obf]";
        if ( $( element ).length > 0 ) {
            if ( !Modernizr.touchevents ) {
                let ctrl = 0;
                $( window ).on( 'keydown', function ( e ) {
                    if ( e.which == 17 || e.which == 91 ) {
                        ctrl = true;
                    }
                } );
                $( window ).on( 'keyup', function () {
                    ctrl = false;
                } );
                
                $( document ).on( 'mouseup', element, function ( e ) {
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( e.which == 1 || e.which == 2 ) {
                        let blank = false;
                        if ( e.which == 2 ) {
                            blank = true;
                        } // Clic molette
                        if ( target == "_blank" ) {
                            blank = true;
                        }
                        if ( blank || ctrl ) {
                            window.open( url, '_blank' );
                        } else {
                            window.location = url;
                        }
                        return false;
                    }
                    
                    return false;
                    
                } );
            } else {
                $( document ).on( 'click', element, function ( e ) {
                    let blank  = false;
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( target == "_blank" ) {
                        blank = true;
                    }
                    if ( blank ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                } );
            }
        }
    }
    
    static change_height_nav()
    {
        $( window ).on( 'load scroll', function () {
            let scroll_top = $( this ).scrollTop();
            if ( scroll_top > 1 ) {
                $( 'body' ).addClass( 'header--fit' );
            } else {
                $( 'body' ).removeClass( 'header--fit' );
            }
        } );
    }
    
    static hidding_toolbar()
    {
        let last_scroll_top = 0;
        $( window ).on( 'load scroll', function () {
            
            let scroll_top = $( this ).scrollTop();
            let $navbar    = $( '[data-id="wpiris-toolbar"]' );
            
            if ( scroll_top >= last_scroll_top && scroll_top > $('header').outerHeight() ) {
                // Down
                $( 'body' ).addClass( 'toolbar-is-hidden' );
            } else {
                // Up
                $( 'body' ).removeClass( 'toolbar-is-hidden' );
            }
            
            last_scroll_top = scroll_top;
        } );
    }
    
    static tab_module()
    {
        const trigger  = '[data-trigger="wpiris-tab-module"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            
            let $element = $(this),
                item  = $element.attr('href');
            
            if ( !$element.hasClass('is-active') ) {
                $element.closest('.tabModule').find('.tabTrigger').removeClass('is-active');
                $element.addClass('is-active');
                $element.closest('.tabModule').find('.tabWrapper .tabItem').hide().removeClass('is-active');
                $(item).fadeIn().addClass('is-active');
                
                $element.trigger('tab-active');
            }
        });
    }

    static isotope() {

        const grid = document.querySelector('[data-isotope-grid]'),
            $grid = $('[data-isotope-grid]'),
            $filters = $('[data-isotope-filters]'),
            current_class = 'current';

        if ( $grid.length > 0 ) {

            let filter_init = $('[data-isotope-filter]').first().attr('data-isotope-filter');

            // Init isotop
            var isotope = new Isotope( grid, {
                itemSelector: '[data-isotope-item]',
                filter: filter_init,
                masonry: {
                    columnWidth: '[data-isotope-grid-sizer]',
                    gutter: '[data-isotope-gutter-sizer]',
                },
            } );

            // Filters
            if ($filters.length > 0) {

                // Filter items on button click
                $filters.on('click', 'a', function (e) {
                    e.preventDefault();
                    let filter_value = $(this).attr('data-isotope-filter');
                    isotope.arrange({filter: filter_value});
                });

                // Change class on click
                $filters.each(function (i, button_group) {
                    let $button_group = $(button_group);
                    $button_group.on('click', 'a', function () {
                        $button_group.find('.' + current_class).removeClass(current_class);
                        $(this).addClass(current_class);
                    });
                });
            }
        }
    }

    // TODO: remove > Replace all img (local)
    static local_pictures(){
        $('img').not('.footerStamp').not('.strateHeadingVisual').each(function(){
            $(this).attr('src', Theme.theme_url + '/assets/src/images/picture.jpg');
            $(this).attr('data-src', Theme.theme_url + '/assets/src/images/picture.jpg');
        })
    }
}
